export default __webpack_public_path__ + "static/media/Group 171.1f6c7912.png";